import React from 'react';


export default function Calendar(props) {
    return (
        <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M6 4H4V3H2V6H18V3H16V4H14V3H6V4ZM18 8H2V18H18V8ZM14 1H6V0H4V1H2C0.89543 1 0 1.89543 0 3V18C0 19.1046 0.89543 20 2 20H18C19.1046 20 20 19.1046 20 18V3C20 1.89543 19.1046 1 18 1H16V0H14V1ZM5 12V10H7V12H5ZM9 12H11V10H9V12ZM13 12V10H15V12H13ZM5 14V16H7V14H5ZM11 16H9V14H11V16Z" fill="#1FCCCD"/>
        </svg>
    );
}
